export const fieldTranslations = {
  name: "Name",
  amf_monetary_type: "Amf Monetary Type ",
  sector: "Sector",
  old_sector: "Old Sector",
  issuer_type: "Issuer Type",
  exposition_issuer_type: "Exposition Issuer Type",
  exposition_issuer_rating: "Exposition Issuer Rating",
  type_of_identification_code_for_issuer_group:
    "Type of Identification Code for Issuer Group ",
  country: "Country",
  fund_registration_country: "Fund Registration Country",
  industry: "Industry",
  source: "Source",
  lei: "Lei",
  vigeo_key: "Vigeo Key",
  vigeo_title: "Vigeo Title",
  name_of_the_group_of_the_issuer: "Name of the Group of the Issuer",
  identification_of_the_group: "Identification of the Group",
  economic_sector: "Economic Sector",
  sustainalytics_entity_name: "Sustainalytics Entity Name",
  msci_entity_id: "MSCI Entity Id",
  msci_entity_name: "MSCI Entity Name",
  market_cap_amount: "Market Cap Amount",
  market_cap_currency: "Market Cap Currency",
  market_cap_amount_in_usd: "Market Cap Amount (USD)",
  sustainalytics_entity_id: "Sustainalytics Entity Id",
  direct_parent_name: "Direct Parent Name",
  ultimate_parent_name: "Ultimate Parent Name",

  // Technical fields
  created_at: "Créé le",
  updated_at: "Mis à jour le",
};
